import React from 'react';

import { TextField } from '@mui/material';

interface Props {
  ariaLabel: string;
  value?: number;
  onChange: (value?: number) => void;
}

export default function NumberField({ ariaLabel, onChange, value }: Props) {
  return (
    <TextField
      inputProps={{ 'aria-label': ariaLabel, min: 0, step: 1 }}
      onChange={(event) => {
        const nextValue = event.target.value === '' ? undefined : Number(event.target.value);
        onChange(Number.isFinite(nextValue) ? nextValue : undefined);
      }}
      size="small"
      type="number"
      value={value ?? ''}
      sx={{ minWidth: 130 }}
      fullWidth
    />
  );
}
